import getCommonDataBank from "@/router/middleware/getCommonDataBank";
import getSysParameters from "@/router/middleware/getSysParameters";
import getRequestFl from "@/router/middleware/getRequestFl";
export default {
    name: 'bankApplications',
    path: '/bank',
    component: () => import('@/views/individual/index.vue'),
    children: [
        {
            name: 'requestsFl',
            path: 'applications',
            component: () => import('@/views/individual/RequestsFl.vue'),
            meta:{
                middleware:[
                    getCommonDataBank,
                    getRequestFl,
                ]
            }
        },
        {
            name: 'requestFl',
            path: 'application/:id',
            component: () => import('@/views/individual/RequestFl.vue'),
            props: true,
            meta:{
                middleware:[
                    getCommonDataBank,
                    getSysParameters,
                ]
            }
        }
    ]
};
